import { HttpErrorResponse } from '@angular/common/http';
import type {} from '@angular/localize/init';
import { BpMarketSelectionRateFormatted } from '@bcf-vanilla-ts-v1-api-access/bp-api/models/bp-market';
import { of, OperatorFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

export type RatesChangedData = Record<string, BpMarketSelectionRateFormatted>;

export class PlaceBetApiError {
  constructor(
    public readonly message: string,
    public readonly title: string,
    public readonly code: number | string,
    public readonly ratesChangedData?: RatesChangedData | undefined
  ) {}

  public static fromHttpError<T>(): OperatorFunction<T, PlaceBetApiError | T> {
    return catchError((err: HttpErrorResponse) => {
      const errorMessage: string =
        err.error?.detail ??
        err.error?.message ??
        $localize`Ooups, something goes wrong! : Server Error: ${err.status}`;
      return of(
        new PlaceBetApiError(
          errorMessage,
          err.error?.title ?? '',
          err.error?.code ?? '',
          err.error?.exc_data ?? undefined
        )
      );
    });
  }

  public hasBonusSettingsRestrictionsError(): boolean {
    return this.code === 5032;
  }

  public hasRatesChanged(): boolean {
    return this.code === 5001;
  }

  public hasNotEnoughMoney(): boolean {
    return this.code === 3001 || this.code === 5035;
  }

  public hasNoFundsInRealMoney(): boolean {
    return this.code === 101;
  }
}
